import { ReactNode } from "react"
import { useIntl } from "react-intl"

import { StaffLabelTextM } from "@doktor-se/bones-ui"
import { Queue } from "@doktor-se/bones-ui/dist/web-shared/types"

import { useAppSelector } from "lib/hooks"
import { queueCountSelectors, selectFilteredQueueCount } from "reducers/queue/queue.reducer"

import FilterButton from "./FilterButton"

import styles from "./QueueList.module.scss"

interface QueueListProps {
  queues: Queue[]
  activeFilter: string
  onClick: (key: string) => void
  children: ReactNode
}

const QueueList = ({ queues, activeFilter, onClick, children }: QueueListProps) => {
  const intl = useIntl()
  const appLanguage = useAppSelector(state => state.app.language)
  const searchFilter = useAppSelector(state => state.conversations.searchFilter)
  const queueCounts = useAppSelector(selectFilteredQueueCount)
  const queueCountEntities = useAppSelector(queueCountSelectors.selectEntities)

  const queueLabel = (queue: Queue) => {
    // Use filtered counts when search is active, otherwise use regular counts
    let count = 0

    if (searchFilter) {
      const filteredCount = queueCounts.find(q => q.key === queue.queueKey)
      count = filteredCount?.conversationCount || 0
    } else {
      count = queueCountEntities[queue.queueKey]?.conversationCount || 0
    }

    return `${queue.translations[appLanguage]} (${count})`
  }

  return (
    <div>
      <StaffLabelTextM style={{ marginBottom: "8px", marginTop: "18px" }}>
        {intl.formatMessage({ id: "label.queues" })}
      </StaffLabelTextM>
      <div className={styles.list}>
        {queues.map(q => (
          <FilterButton
            active={activeFilter === q.queueKey}
            key={q.queueKey}
            label={queueLabel(q)}
            onClick={() => onClick(q.queueKey)}
            filter={q.queueKey}
          />
        ))}
        {children}
      </div>
    </div>
  )
}

export default QueueList
